module.exports = __webpack_public_path__ + "static/media/6.question.fbade690.mp4";